import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Home from "app/pages/Home";
import Writer from "app/pages/Writer";
import Studio from "app/pages/Studio";

import withTracker from "app/utils/withTracker";

class App extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={withTracker(Home)} />
        <Route exact path="/writer">
          <Redirect to="/" />
        </Route>
        <Route exact path="/studio" component={withTracker(Studio)} />
        <Redirect from="*" to="/" />
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js